import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useEffect } from "react";
import NotFound from "@/pages/NotFound";
import { Route, Switch, useLocation } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Register from "./pages/Register";
import MyPage from "./pages/MyPage";
import Exam from "./pages/Exam";
import Result from "./pages/Result";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Syllabus from "./pages/Syllabus";
import PaymentSuccess from "./pages/PaymentSuccess";
import Tokushoho from "./pages/Tokushoho";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import RequestReset from "./pages/RequestReset";
import ResetPassword from "./pages/ResetPassword";

function ScrollToTopOnRouteChange() {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location]);

  return null;
}

function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <Switch>
      <Route path={"/"} component={Home} />
      <Route path={"/login"} component={Login} />
      <Route path={"/signup"} component={Signup} />
      <Route path={"/request-reset"} component={RequestReset} />
      <Route path={"/reset-password"} component={ResetPassword} />
      <Route path={"/register"} component={Register} />
      <Route path={"/register/payment-success"} component={PaymentSuccess} />
      <Route path={"/my-page"} component={MyPage} />
      <Route path={"/exam/:registrationId"} component={Exam} />
      <Route path={"/result/:sessionId"} component={Result} />
      <Route path={"/syllabus"} component={Syllabus} />
      <Route path={"/syllabus/:levelId"} component={Syllabus} />
      <Route path={"/tokushoho"} component={Tokushoho} />
      <Route path={"/terms"} component={Terms} />
      <Route path={"/privacy"} component={Privacy} />
      <Route path={"/admin"} component={Admin} />
      <Route path={"/404"} component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
    </Switch>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
        // switchable
      >
        <TooltipProvider>
          <ScrollToTopOnRouteChange />
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
